import { useTranslation } from "react-i18next"

import { getPercentSymbol } from "@/utils/percent"

interface UsePercentSymbolProps {
  includeSpacing?: boolean
}

/**
 * The usePercentSymbol service returns the percent symbol string that should displayed based on the locale
 *
 * @returns The percent symbol string
 * @example
 * const percentSymbol = usePercentSymbol(i18n.language, { includeSpacing: true })
 */
export const usePercentSymbol = (props: UsePercentSymbolProps = {}): string => {
  const { i18n } = useTranslation()

  const symbol = getPercentSymbol(i18n.language, {
    includeSpacing: props.includeSpacing ?? false,
  })

  return symbol
}
